import { useEffect, useState } from "react";
import {
	Button,
	Card,
	CardBody,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Table,
} from "reactstrap";
import { ReactComponent as AddIcon } from "../../../../../assets/utils/images/svgs/addBlue.svg";
import { ReactComponent as RemoveIcon } from "../../../../../assets/utils/images/svgs/remove-blue.svg";
import RolesIcon from "./RolesIcon";
import { userRoles } from "../helpers";
import { toast } from "react-toastify";
import Loader from "react-loaders";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { useAddRemoveCommunity, useCommunityList, useUpdateUserRole, useUserRoles } from "Api/Coordinator/Gebruikers/Algemeen";

const Role = () => {
	const { currentUser, disable,  fetchAdminCommunityList } = useGebruikerContext();
	const [communityModal, setCommunityModal] = useState(false);
	const [removeCommunityModal, setRemoveCommunityModal] = useState(false);
	const [currentCommunity, setCurrentCommunity] = useState();


	const {
		data: rolesResponse,
		isLoading: loader,
		mutate: mutateRoles,
	} = useUserRoles(currentUser?.data?.clooserId);

	const rolesData = rolesResponse?.data || [];

	useEffect(() => {
		if (rolesResponse) {
			fetchAdminCommunityList();
		}
	}, [rolesResponse]);


	const {
		data: communityResponse,
		mutate: mutateCommunityList,
	} = useCommunityList(
		communityModal ? currentUser?.data?.clooserId : null
	);

	const communityList = communityResponse?.data || [];

	const { trigger: updateUserRole } = useUpdateUserRole();
	const { trigger: addRemoveCommunity } = useAddRemoveCommunity();

	const updateUserRoleHandler = async (
		userType = "",
		commId = "",
		value = "",
		contractId = "",
		schoolId = "",
	) => {
		if (disable) {
			return
		}
		const payload = {
			iAdminId: currentUser.data.clooserId,
			role: userType,
			iCommunityId: commId,
			value,
			iContractId: contractId,
			schoolId,

		};
		try {
			const response = await updateUserRole({ data: payload });

			if (response.status) {
				await mutateRoles();
			} else {
				toast.error("Rol niet bijgewerkt! Er is iets misgegaan.");
			}
		} catch (error) {
			console.error(`API error:`, error);
		}
	};

	const addRemoveCommunityHandler = async (actionType) => {
		if (!currentCommunity) return;
		const payload = {
			iAdminId: currentUser.data.clooserId,
			iCommunityId: Number(currentCommunity),
			type: actionType,
		};
		try {
			const response = await addRemoveCommunity({ data: payload });
			if (response.status) {
				await mutateRoles();
				setRemoveCommunityModal(false);
				setCommunityModal(false);
				toast.success("Gebruiker heeft de verbinding met de rollen succesvol verbroken.");
			} else {
				toast.error("Kan de gebruiker niet loskoppelen van de rollen.");
			}
		} catch (error) {
			console.error(`API error:`, error);
		}
	};

	return (
		<Card className="main-card " style={{ height: "448px" }} >
			<CardBody className="d-flex flex-column table-responsive" style={{ height: "100%" }}>
				<h5 className="rollen-title">Rollen</h5>

				{loader ? (
					<Loader
						type="ball-grid-pulse"
						className={"mt-3 d-flex mx-auto justify-content-center"}
					/>
				) : (
					<>
						<div style={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
							<Table className="role-tb">
								<thead className="rollen-table mb-4">
									<tr>
										<th><span></span></th>
										<th><span>Vervanger</span></th>
										<th><span>Melder</span></th>
										<th><span>Coordinator</span></th>
										<th><span>Ontkoppelen</span></th>
									</tr>
								</thead>

								<tbody>
									{(rolesData && rolesData.length) ? (
										rolesData.map((item) => {
											return (
												<tr key={item.iCommunityId}>
													<td>{item.vCommunityName}</td>
													<td>
														<RolesIcon
															iAdminId={currentUser.data.clooserId}
															contractId={item.contractId}
															selectedSchoolId={item.schoolList.map(
																(item) => item.id
															)}
															value={item.isSubstitutor}
															id={item.iCommunityId}
															vOrg={item.vCommunityName}
															name={currentUser.data.name}
															type={userRoles.Vervanger}
															updateHandler={updateUserRoleHandler}
														/>
													</td>
													<td>
														<RolesIcon
															iAdminId={currentUser.data.clooserId}
															selectedSchoolId={item.schoolList.map(
																(item) => item.id
															)}
															value={item.isRequestor}
															id={item.iCommunityId}
															vOrg={item.vCommunityName}
															name={currentUser.data.name}
															type={userRoles.Melder}
															updateHandler={updateUserRoleHandler}
														/>
													</td>
													<td>
														<RolesIcon
															iAdminId={currentUser.data.clooserId}
															selectedSchoolId={item.schoolList.map(
																(item) => item.id
															)}
															value={item.isCoordinator}
															vOrg={item.vCommunityName}
															id={item.iCommunityId}
															name={currentUser.data.name}
															type={userRoles.Coordinator}
															updateHandler={updateUserRoleHandler}
														/>
													</td>
													<td className="text-center">
														<RemoveIcon
															onClick={() => {
																setRemoveCommunityModal(true);
																setCurrentCommunity(item.iCommunityId);
															}}
															fontSize={"18px"}
															className="cursor-pointer"
														/>
													</td>
												</tr>
											);
										})
									) :
										(
											<p>Geen rollen toegevoegd</p>
										)

									}

								</tbody>
							</Table>
							<div className="text-center mt-4 d-flex justify-content-center">
								<Button
									outline
									className="btn-outline-primary-blue btn-color-style d-flex justify-content-center align-items-center gap-2"
									onClick={() => {
										setCommunityModal(true);
									}}
									type="button"
									color="primary"
									disabled={disable}
								>
									Bestuur <AddIcon />
								</Button>
							</div>
						</div>
					</>
				)}
				<Modal
					isOpen={communityModal}
					toggle={() => {
						setCommunityModal((prev) => !prev);
					}}
					className="feedback-modal-style link-form modal-centered"
				>
					<ModalHeader
						toggle={() => {
							setCommunityModal((prev) => !prev);
						}}
					>
						Niet gekoppelde besturen
					</ModalHeader>
					<ModalBody className="py-5">
						{communityList.length === 0 &&
							"Er zijn geen gemeenschapsgegevens beschikbaar."}
						{communityList.length > 0 && (
							<select
								className="form-select"
								onChange={(e) => {
									setCurrentCommunity(e.target.value);
								}}
							>
								<option value="">Alle besturen</option>
								{communityList.map((item) => {
									return (
										<option key={item.iCommunityId} value={item.iCommunityId}>
											{item.vCommunityName}
										</option>
									);
								})}
							</select>
						)}
					</ModalBody>
					<ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4">
						<Button
							className="btn-color-style opslaan-btn"
							size="sm"
							outline
							color="primary"
							type="button"
							onClick={() => {
								addRemoveCommunityHandler("add");
							}}
						>
							Toevoegen
						</Button>
					</ModalFooter>
				</Modal>
				{!disable ? <Modal
					isOpen={removeCommunityModal}
					toggle={() => {
						setRemoveCommunityModal((prev) => !prev);
					}}
					className="feedback-modal-style link-form modal-centered"
				>
					<ModalHeader
						toggle={() => {
							setRemoveCommunityModal((prev) => !prev);
						}}
					></ModalHeader>
					<ModalBody className="py-4">
						<h5 style={{ color: "#ff8b02" }} className="mb-3">
							Hiermee ontkoppelen we deze gebruiker van de onderstaande rollen, weet u
							dit zeker?
						</h5>
						<p>
							Hiermee worden de bestuursgegevens van de vervanger verwijderd en de
							vervanger ontkoppeld van het bestuur. De dagdeel gegevens worden niet
							verwijderd. Dit kan niet ongedaan gemaakt worden.
						</p>
					</ModalBody>
					<ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4">
						<Button
							className="btn-color-style opslaan-btn"
							size="lg"
							outline
							color="primary"
							type="button"
							onClick={() => addRemoveCommunityHandler("remove")}
						>
							Toepassen
						</Button>
						<Button
							className="btn-color-style opslaan-btn"
							size="lg"
							outline
							color="primary"
							type="button"
							onClick={() => setRemoveCommunityModal(false)}
						>
							Annuleren
						</Button>
					</ModalFooter>
				</Modal> : null}
			</CardBody>
		</Card>
	);
};

export default Role;
